import { createRoot } from "react-dom/client";
import CourseApplicationModalWrapper from "../components/CourseApplicationModalWrapper";

class CourseModalElement extends HTMLElement {
  connectedCallback() {
    const root = createRoot(this.attachShadow({ mode: 'open' }));
    root.render(<CourseApplicationModalWrapper />);
  }
}

customElements.define('course-modal', CourseModalElement);